import { TicketStatusEnum } from 'types/ticket'

export enum BotModeEnum {
  app = 'app',
  web = 'web',
}

export enum LanguagesEnum {
  en = 'en',
  it = 'it',
}

export enum WebsocketActionsEnum {
  NEW_MESSAGE = 'new_message',
  CHAT_NAME_SET = 'chat_name_set',
  STREAM = 'stream',
  END_STREAM = 'end_stream',
  UPDATE_CHAT_PARTICIPANTS = 'update_chat_participants',
  ATTACHMENT_PARSE_SUCCESS = 'attachment_parse_success',
  ATTACHMENT_PARSE_FAILED = 'attachment_parse_failed',
  TICKET_STATUS_UPDATE = 'ticket_status_update',
}

export type ChatWebSocketMessage = {
  action: WebsocketActionsEnum
  body: any
  messageId: string
}

export type TicketStatusUpdateBody = {
  ticketId: string
  chatId: string
  status: TicketStatusEnum
}

export type BotMode = BotModeEnum.app | BotModeEnum.web

export type GetValues<T> = T[keyof T]
